import axios from 'axios'
import { deepFreeze, encodeImageUrl } from '../../../features/common/Utilities'
import { youtube_parser } from '../../../features/common/utils/utils'
import { FILES_ENDPOINT } from 'cfgCommon/endpoints'

const ongoingRequests = new Map()

export async function getFileAssociations({ id }, type) {
  if (!id) return []

  const cacheKey = `${id}_${type}`

  if (ongoingRequests.has(cacheKey)) {
    return ongoingRequests.get(cacheKey)
  }

  const requestPromise = axios(`${FILES_ENDPOINT}/${type}/${id}`)
    .then((res) => {
      const files = deepFreeze(res.data.data)
      ongoingRequests.delete(cacheKey)
      return files
    })
    .catch((error) => {
      ongoingRequests.delete(cacheKey)
      throw error
    })

  ongoingRequests.set(cacheKey, requestPromise)
  return requestPromise
}

export async function getFileOnlyImages({ id }, type) {
  const files = await getFileAssociations({ id }, type)
  const imgs = files
    .filter((file) => file.type.name.includes('image/'))
    .map((file) => {
      if (file.thumbnail) {
        let thumbnail = file.thumbnail_url || 'th-' + file.name
        let mini = file.mini_url || file.thumbnail

        return {
          ...file,
          full_size: encodeImageUrl(file.url),
          original: encodeImageUrl(thumbnail),
          thumbnail: encodeImageUrl(mini),
        }
      } else {
        console.warn('App', `Imagen ${file.url} no tiene thumbnails`)
        return {
          ...file,
          full_size: encodeImageUrl(file.url),
          original: encodeImageUrl(file.url),
          thumbnail: encodeImageUrl(file.url),
        }
      }
    })
  return imgs
}

export async function getFileImagesAndVideos({ id }, type, filesParam = []) {
  let files = filesParam
  if(!files.length){
    files = await getFileAssociations({ id }, type)
  }
  const imgsAndVideos = files
    .filter((file) => file.type.name.includes('image/') || file.type.name.includes('video/youtube'))
    .map((file) => {
      if (file.thumbnail) {
        if(file.type.name.includes('video/youtube')){
          const youtube_id = youtube_parser(file.url);
          const thumbnail_url = `https://i1.ytimg.com/vi/${youtube_id}/default.jpg`;
          const youtubeParams = '?autoplay=0&showinfo=0&controls=0&enablejsapi=1'
          let youtubeUrl = file.url.replace('watch?v=', 'embed/')
          youtubeUrl = youtubeUrl + youtubeParams
          return{
            ...file,
            full_size: thumbnail_url,
            original: thumbnail_url,
            thumbnail: thumbnail_url,
            embedUrl: youtubeUrl
          }
        }
        let thumbnail = file.thumbnail_url || 'th-' + file.name
        let mini = file.mini_url || file.thumbnail

        return {
          ...file,
          full_size: encodeImageUrl(file.url),
          original: encodeImageUrl(thumbnail),
          thumbnail: encodeImageUrl(mini),
        }
      } else {
        console.warn('App', `Imagen ${file.url} no tiene thumbnails`)
        return {
          ...file,
          full_size: encodeImageUrl(file.url),
          original: encodeImageUrl(file.url),
          thumbnail: encodeImageUrl(file.url),
        }
      }
    })
  return imgsAndVideos
}
